// @ts-nocheck
(function() {
'use strict';

angular
    .module('TR')
    .controller('Booking', Booking)
    .directive('backButton', function($window) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            controller: ($scope, $routeParams, $location) => {
                $scope.goBack = function() {
                    if ($scope.isHolidayOrFlightType) {
                        $location.url(`holidays/options/${$routeParams.tripId}`);
                    } else {
                        $window.history.back();
                    }
                };
            },
            template: '<input type="button" ng-click="goBack($event)" value="Back" />'
        };
    });

function Booking(
    $anchorScroll,
    $filter,
    $location,
    $q,
    $route,
    $routeParams,
    $rootScope,
    $sce,
    $scope,
    $timeout,
    $window,
    abTest,
    analytics,
    arrayUtil,
    agentModeService,
    authService,
    basketService,
    bd4travel,
    basketStore,
    bookingCompleteTrackingService,
    bookingService,
    bookingStatus,
    broker,
    criteoService,
    cookieService,
    costBreakdownCodes,
    currencyService,
    dateUtil,
    ecommerceService,
    guidService,
    insuranceService,
    modalService,
    occupancyService,
    paymentsCalculator,
    paymentsService,
    paymentsUtilService,
    quoteService,
    resourceService,
    savedSearchService,
    scrollService,
    searchUnitService,
    taxationService,
    tokeniser,
    tripService,
    trackingPixelsService,
    adFormService,
    pricingService,
    flightDetail) {
    const cm = this;
    const thisYear = new Date().getFullYear();
    const ppResp = {
        cancel: 'PAYPALCANCELLED',
        fail: 'PAYPALFAILED'
    };
    const paymentTabOptions = {
        Card: 0,
        PayPal: 1,
        SavedCards: 2
    };

    let paypalInContextSet = false;
    let cards;

    function changeWorkflowState(n) {
        basketService.changeJourneyUrl(n);
    }

    cm.agentMode = TRPCONFIG.Domain.isAgentMode;
    cm.WPIframeUpdate = TRPCONFIG.Domain.WPIframeUpdate;
    cm.threeDS2Enabled = TRPCONFIG.Domain.ThreeDS2EnabledTR;
    cm.directPaymentCaveat = directPaymentCaveat;
    cm.changeWorkflowState = changeWorkflowState;
    cm.acceptedAgencyTerms = false;
    cm.checkbox = {
        specialRequests: false,
        cancellationProtection: false
    };
    cm.pixels = [];
    cm.checkoutTrackingProviders = ['roomerflex'];
    cm.feePercent = 0;
    cm.feeAmount = 0;
    cm.months = arrayUtil.numberArray(1, 12);
    cm.detailsMatch = bookingService.detailsMatch;
    cm.pastYears = arrayUtil.numberArray(thisYear - 10, thisYear);
    cm.productId = $routeParams.productId;
    cm.signIn = signIn;
    cm.signOut = signOut;
    cm.threedsRedirecting = false;
    cm.WPHostedRedirect = false;
    cm.copyFromContact = copyFromContact;
    cm.years = arrayUtil.numberArray(thisYear, thisYear + 20);
    cm.driverOptions = bookingService.driverOptions;
    cm.adultTitles = bookingService.getAdultTitles();
    cm.agentModeEnabled = !!$rootScope.user.Agent;
    // if agentMode is enabled this check needs to be manually checked
    // if agentMode is not enabled this check needs to be automatically checked
    cm.agentImportantNoticeCheck = !cm.agentModeEnabled;
    cm.paymentAmountWithCardFee = 0;
    cm.dontCaptureAddress = false;
    cm.bookingLoaded = undefined;
    cm.paymentModel = paymentsUtilService.createEmptyPaymentModel();
    cm.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
    cm.importantInfoContent = '';
    cm.showTakingPaymentModal = false;
    cm.isSecurityCodeMasked = false;
    cm.isNotCash = true;
    cm.discount = 0;
    cm.voucherCode = cookieService.get('VoucherCode') || '';
    cm.voucherCodeInput = cookieService.get('VoucherCode') || '';
    cm.voucherDiscountMsg = JSON.parse(cookieService.get('VoucherWarnMessage')
    || '{ "Message": "", "Code": 0 }') || { Message: '', Code: 0 };
    cm.isDiscountMsgPositive = false;
    cm.showDiscountAppliedBox = false;
    cm.discountAppliedBoxMsg = 'Voucher code discount applied';
    cm.isHasActiveVouchers = false;
    cm.isDiscountApplied = isDiscountApplied;
    cm.isHFareFlightType = isHFareFlightType;
    cm.enbdOptionId = TRPCONFIG.Domain2.EnbdPaymentOptionId;
    cm.threeDS2AwaitDDC = TRPCONFIG.Domain.ThreeDS2AwaitDDC;
    cm.enbdDetails = {
        cardNumber: null,
        isCpgValid: null,
        isOtpValid: null,
        sessionToken: null,
        transactionId: null,
        domainId: TRPCONFIG.Domain.DomainId,
        currencyCode: cm.currencyCode,
        isPointsPaymentApproved: null,
        pointsToRedeem: null,
        amountToRedeem: null,
        availablePoints: null,
        balanceData: null,
        isCpgInProgress: null,
        isOtpInProgress: null,
        isOtpResent: null,
        showZeroBalanceAlert: null,
        cardNumberMinLength: 13
    };
    cm.isBookingDisabled = false;
    cm.showCovidPaymentDisclaimer = false;
    cm.isHoliday = false;
    cm.isTransfer = false;
    cm.ancillaries = false;
    cm.showBreadcrumbs = false;
    cm.hideForm = false;
    cm.threeDsValidationComplete = false;
    const cpgStatusApiEnabled = TRPCONFIG.Domain.CpgStatusApiEnabled;


    function onCpgStatusAPIError(err) {
        if (err && err.error) {
            const error = err.error;
            cm.threedsRedirecting = false;
            cm.hideForm = true;

            const paymentTakenMsg = `${resourceService.get('PAYMENTTAKEN')} ${resourceService.get('TELEPHONENUMBER')}`;

            const paymentFailedMsg = `${resourceService.get('PAYMENTFAILED')} CPG Payment Failed<br/><br/> ${String.format(resourceService.get('PAYMENTASSISTENCE'),
            resourceService.get('TELEPHONENUMBER'))}`;

            const errorMsg = error === 'TIMER' ? paymentTakenMsg : paymentFailedMsg;

            $scope.$broadcast('flash:error', errorMsg);
        }
    }

    $scope.$on('cpgStatusAPIError', function(ev, err) {
        if (err && err.error) {
            onCpgStatusAPIError(err);
        }
    });

    cm.getVouchers = () => {
        pricingService.hasActiveVouchers().then(data => {
            cm.isHasActiveVouchers = data;
        });
    };

    if (TRPCONFIG.Domain.IsAddVoucherEnabled) {
        cm.getVouchers();
    }

    cm.reloadPage = event => {
        event.preventDefault();
        window.location.reload();
    };


    switch (cm.voucherDiscountMsg.Code) {
        case 1:
            cm.isDiscountMsgPositive = false;
            break;
        case 2:
            cm.isDiscountMsgPositive = false;
            break;
        case 3:
            cm.isDiscountMsgPositive = false;
            cm.showDiscountAppliedBox = true;
            break;
        case 4:
            cm.isDiscountMsgPositive = true;
            cm.voucherDiscountMsg.Message = 'Voucher code not applied. <b>You already have a better deal!</b>';
            break;
        case 5:
            cm.isDiscountMsgPositive = true;
            cm.showDiscountAppliedBox = true;
            cm.voucherDiscountMsg.Message = 'Your new discount has been applied. <b>You’ve bagged an even better deal!</b>';
            break;
        case 6:
            cm.isDiscountMsgPositive = true;
            cm.showDiscountAppliedBox = true;
            break;
        case 7:
            cm.isDiscountMsgPositive = true;
            cm.showDiscountAppliedBox = true;
            cm.discountAppliedBoxMsg = 'Voucher code discount removed';
            break;
    }

    let bookingId = '';

    _block();

    let bookingFormVersion = 0;

    //if the pb query string parameter is set, that means that we need to re-run prepare booking
    //this happens when we are being re-directed here after a signin event.
    if ($routeParams.pb) {
        tripService.setBookingId($routeParams.tripId, guidService.uuid()).then(function(t) {
            bookingService.prepareBooking(t.BasketId, t.BookingId, $routeParams.tripId);
            authService.bufferRoute(null);  //clear any buffered route that might be left behind
            $location.replace();
            $location.search('pb', null);
        });
        return;
    }

    tripService.getCurrency($routeParams.tripId).then(cur => {
        cm.currencyCode = cur;
        cm.currencySymbol = currencyService.getSymbol(cur);
    });

    tripService.getTrip($routeParams.tripId).then(function(trip) {
        const basketId = trip.BasketId;
        const isHoliday = trip.TripType === tripService.tripTypes.Holiday;
        const isTransfer = trip.TripType === tripService.tripTypes.Transfer;
        const isParking = trip.TripType === tripService.tripTypes.Parking;
        bookingId = trip.BookingId;
        if (!bookingId) {
            bookingId = trip.BookingProcessId;
        }

        cm.trip = trip;
        cm.tripId = trip.TripId;
        cm.basketId = basketId;
        cm.sharedUseFlag = false;
        cm.isHoliday = isHoliday;
        cm.isTransfer = isTransfer;
        cm.isParking = isParking;
        cm.showAgentBookingMessage = isTransfer || isParking;
        cm.showBreadcrumbs = !trip.QuoteId;

        if (!trip.FlightsRequest && trip.HotelsRequest) {
            let totalRooms = trip.HotelsRequest.Rooms && trip.HotelsRequest.Rooms.length || 0;
            let singleRoomOnly = TRPCONFIG.Domain.ParasolHotelBookingSingleRoomOnly && totalRooms === 1;
            let isMobile = TRPCONFIG.IsMobileView;
            let goV3 = isMobile && (TRPCONFIG.Domain.ParasolHotelBooking && singleRoomOnly)
                || (TRPCONFIG.Domain.ParasolHotelBooking && !TRPCONFIG.Domain.ParasolHotelBookingSingleRoomOnly);

            if (goV3) {
                $window.location.href = `booking/summary/${cm.tripId}?gov=3`;
            }
        }

        //only set the booking form version if we are on a page type that
        //will be supporting it.
        if (isHoliday || cm.trip.TripType === tripService.tripTypes.Flight) {
                bookingFormVersion = parseInt(cookieService.get('BookingFormVersion') || 0);
                $scope.isHolidayOrFlightType = true;
            }

        if (cm.trip.TripType === tripService.tripTypes.Hotel) {
            $scope.isHotelJourney = true;
        }

        $q.all([bookingService.getBooking(bookingId, cm.tripId),
            basketStore.all(basketId, $routeParams.productId),
            basketStore.rules(basketId, $routeParams.productId),
            basketStore.costBreakdown(basketId, $routeParams.productId),
            basketStore.totalDeposit(basketId, $routeParams.productId),
            basketStore.totalCost(basketId),
            basketStore.payments(basketId),
            basketStore.balancesDue(basketId, $routeParams.productId),
            basketStore.hotelCost(basketId),
            basketStore.getCancellationProtectionQuote(basketId),
            basketStore.getTaxAdjustmentValue(basketId),
            basketStore.carHireRequestedItemsCosts(basketId),
            basketStore.payDepositAggregates(basketId)
        ]).then(function([
                booking,
                products,
                rules,
                costBreakdown,
                totalDeposit,
                totalCost,
                payments,
                balancesDue,
                hotelCost,
                cancellationProtection,
                taxAdjustments,
                carHireRequestedItemCosts,
                payDepositAggregates
            ]) {
                if ($routeParams.ppResp) {
                    $scope.$broadcast('flash:error', resourceService.get(ppResp[$routeParams.ppResp]));
                }
                if (booking) {
                    cm.booking = booking;
                    cm.bookingId = cm.booking.BookingProcessId;
                    cm.hotel = products.h;
                    cm.flight = products.f;
                    cm.insurance = products.i;
                    cm.marhaba = products.m;
                    cm.transfer = products.t;
                    cm.parking = products.p;
                    cm.attractions = products.a;
                    cm.carhire = products.c;
                    cm.basketRules = rules;
                    cm.isPackage = Boolean(_.get(cm.flight, 'PackageId') || _.get(cm.hotel, 'PackageId'));
                    const attractionAncillary = cm.attractions && cm.attractions.length > 0;
                    const carhireAncillary = cm.basketRules.captureVehicle;
                    cm.attractionAncillary = Boolean(attractionAncillary);
                    cm.carhireAncillary = carhireAncillary;
                    const airportParkingAncillary = cm.basketRules.captureMainDriver;
                    cm.airportParkingAncillary = airportParkingAncillary;

                    const costType = {
                        Unknown: 0,
                        Accommodation: 1,
                        Discount: 20,
                        AccommodationCancellationProtection: 21,
                        AccommodationLocalFeesAndTaxes: 22,
                        AccommodationExtraTransfer: 23,
                        AccommodationExtraEvent: 24,
                        AccommodationExtraAttraction: 25,
                        AccommodationExtra: 26,
                    };

                    const isMandatoryTransfer = costBreakdown.filter(cost => {
                        const match = _.get(cost, 'ParentId') && _.get(cost, 'TypeId') === (costType.AccommodationExtraTransfer);
                            return match;
                        }).filter(extra => extra);

                    cm.isMandatoryTransfer = isMandatoryTransfer && isMandatoryTransfer.length > 0;
                    cm.isOptionalTransfer = !cm.isMandatoryTransfer && cm.transfer;
                    const ancillaries = cm.carhireAncillary || cm.airportParkingAncillary || cm.attractionAncillary || cm.isOptionalTransfer;
                    cm.ancillaries = ancillaries && Boolean(ancillaries);

                    if ($scope.isHotelJourney && !cm.isPackage) {
                        const extraCostItems = costBreakdown.filter(cost => {
                            const match = _.get(cost, 'ParentId') && _.get(cost, 'TypeId') === (costType.AccommodationExtraTransfer ||
                                costType.AccommodationExtraEvent ||
                                costType.AccommodationExtraAttraction ||
                                costType.AccommodationExtra ||
                                costType.AccommodationLocalFeesAndTaxes ||
                                costType.AccommodationCancellationProtection ||
                                costType.Discount);
                                return match;

                            }).filter(extra => extra);

                        const roomCostItems = costBreakdown.filter(cost => !_.get(cost, 'ParentId')
                        && _.get(cost, 'TypeId') === costType.Accommodation).map((room, LinkId) => {
                            return { ...room, LinkId };
                        });

                        if (extraCostItems && extraCostItems.length > 0 && roomCostItems && roomCostItems.length > 0) {

                            const updatedRoomCostItems = roomCostItems.map(room => {
                                return { RoomId: room.Id, RoomDescription: room.Description };
                            });

                            const enhancedExtras = extraCostItems.map(extras => {
                                return { ...extras, ...updatedRoomCostItems.find(acc => acc.RoomId === extras.ParentId) };
                            });

                            const updatedExtrasCostItems = enhancedExtras.map((extra, LinkId) => {
                                const splitDescription = _.get(extra, 'RoomDescription').split('(');

                                const Description = splitDescription[1] ? `${extra.Description} (${splitDescription[1]}` : extra.Description;
                                return {
                                    ...extra,
                                    Description,
                                    LinkId,
                                };
                            });

                            const updatedCostBreakdown = [...roomCostItems, ...updatedExtrasCostItems];
                            const costsSortedById = updatedCostBreakdown.sort((a, b) => (a.LinkId >= b.LinkId) ? 1 : -1);
                            costBreakdown = costsSortedById;
                        }
                    }
                    cm.costBreakdown = costBreakdown;
                    cm.minDeposit = cm.totalDeposit = totalDeposit;
                    cm.cancellationProtection = cancellationProtection;
                    cm.taxAdjustment = 0;
                    cm.payDepositAggregates = payDepositAggregates;
                    if (taxAdjustments) {
                        cm.taxAdjustment = taxAdjustments;
                    }
                    cm.carHireRequestedItemsCosts = carHireRequestedItemCosts;

                    if (cm.agentModeEnabled) {
                        cm.providersString = agentModeService.buildProvidersString(products);
                        if (cm.flight) {
                            cm.departureDate = cm.flight.Details.Itinerary.DepartureDate;
                        } else if (cm.hotel) {
                            cm.departureDate = cm.hotel.Details.Itinerary.CheckInDate;
                        } else if (cm.transfer) {
                            const itinerary = cm.transfer.Details.Itinerary;
                            cm.departureDate = itinerary.OutboundLeg && itinerary.OutboundLeg.FlightDate ||
                                                itinerary.InboundLeg && itinerary.InboundLeg.FlightDate;
                        }
                        cm.Customer = { Id: cm.booking.UserData.PaymentDetails.CustomerId, Title: cm.booking.UserData.PaymentDetails.CustomerName };
                        if (cm.booking.UserData.PaymentDetails.CustomerId && cm.booking.UserData.PaymentDetails.CustomerName) {
                            customerCreditCheck(cm.Customer);
                        }
                        if (TRPCONFIG.Domain.EnableExtraCustomerInfo) {
                            // In case we are impersonated we have impersonated customer info in UserData object
                            // So we need to set agent email manually
                            cm.booking.UserData.Contact.AgentEmail = $rootScope.agent.Email;

                            // It means that customer is not impersonated and we need to keep customer email empty
                            if (cm.booking.UserData.Contact.AgentEmail === cm.booking.UserData.Contact.Email) {
                                // customer email should not be populated if it's agent's email
                                cm.booking.UserData.Contact.Email = '';
                            }
                        }
                        if (!TRPCONFIG.Domain.EnableExtraContactInfo) {
                            //Even if EnableExtraContactInfo is false , we need to capture the customer address for flights and holidays.
                            cm.dontCaptureAddress = cm.flight == null;
                        }
                        bookingService.resumeRecording(TRPCONFIG.ClientIpAddress);
                    }

                    tripService.usePackageRates().then(packagePrice => cm.packagePrice = packagePrice);

                    cm.booking.UserData.Contact.EmailSignUp = TRPCONFIG.Domain.EmailSignupDefaultValue;

                    if (cm.basketRules.hotelOnly) {
                        tripService.getDurationSummary(searchUnitService.hotel, $routeParams.tripId)
                            .then(ds => cm.durationSummary = ds);

                        if (cm.hotel && cm.cancellationProtection.IsApplicable && cm.cancellationProtection.Quote) {
                            cm.checkbox.cancellationProtection = cm.hotel.Options.some(option => option.OptionId === cm.cancellationProtection.Quote.QuoteId);
                            cm.pixels = cm.checkoutTrackingProviders.map(provider =>
                                trackingPixelsService.getProviderCheckoutUrl(provider, {
                                    quoteId: cm.cancellationProtection.Quote.QuoteId.split('_')[1]
                                })
                            );
                        }
                    }

                    if (cm.basketRules.captureFlight) {
                        if (cm.basketRules.captureInboundFlight) {
                            cm.InboundDestinationAirport = { Code: cm.booking.UserData.ConnectingFlight.InboundDestinationAirport, Title: cm.booking.UserData.ConnectingFlight.InboundDestinationAirportName };
                        }
                        if (cm.basketRules.captureOutboundFlight) {
                            cm.OutboundDepartureAirport = { Code: cm.booking.UserData.ConnectingFlight.OutboundDepartureAirport, Title: cm.booking.UserData.ConnectingFlight.OutboundDepartureAirportName };
                        }
                    }

                    cm.booking.UserData.PaymentDetails.PaymentAmount = cm.booking.paymentAmountInput = cm.minDeposit + cm.booking.UserData.PaymentDetails.DepositAmount;
                    _setPaymentTotalPlusFees();
                    cm.booking.paymentAmountInput = (cm.minDeposit + cm.booking.UserData.PaymentDetails.DepositAmount).toFixed(2);
                    cm.checkbox.specialRequests = arrayUtil.any(cm.booking.UserData.Rooms, function(r) {
                        return r.SpecialRequest;
                    });

                    $scope.$watch('cm.checkbox.specialRequests', function(v) {
                        if (v === false) {
                            cm.booking.UserData.Rooms.forEach(function(r) {
                                r.SpecialRequest = null;
                            });
                            cm.booking.UserData.RequirementsList = [];
                            cm.booking.UserData.RequirementsList[0] = { DisplayRoomNumber: -1, RequirementsText: '', RoomId: -1 };
                        }
                    });

                    if (TRPCONFIG.Domain.CancellationProtectionEnabled) {
                        if (cm.cancellationProtection.Quote != null) {
                            analytics.track('Roomerflex', 'RoomerflexQuoteId', {
                                    QuoteId: cm.cancellationProtection.Quote.QuoteId.replace('canxp_', '')
                            });
                        }
                    }

                    if (cm.basketRules.isAttractionsStandalone) {
                        watchDeliveryOptions();
                    }

                    if (cm.hotel) {
                        cm.booking.UserData.PaymentDetails.HotelDeposit = cm.hotel.PayUsNowAmount;
                        cm.checkInDate = dateUtil.parseDate(cm.hotel.Details.Itinerary.CheckInDate);
                        cm.checkOutDate = dateUtil.parseDate(cm.hotel.Details.Itinerary.CheckOutDate);
                    }

                    if (cm.insurance) {
                        _prepareBookingSubscriber(basketId, trip);
                        cm.documentPaths = insuranceService.getDocumentPaths();
                        if (trip.InsuranceRequest) {
                            cm.insurance.StartDate = trip.InsuranceRequest.StartDate;
                            cm.insurance.EndDate = trip.InsuranceRequest.EndDate;
                        }

                        const policyextras = _.get(cm.insurance, 'Details.InsuranceQuotes[0].Endorsements', []);
                        cm.insurance.PolicyExtras = policyextras && policyextras.length ? policyextras.join(', ') : '';
                    }

                    if (cm.cancellationProtection.IsApplicable && !cm.insurance) {
                        _prepareBookingSubscriber(basketId, trip);
                    }

                    if (cm.flight) {
                        cm.booking.UserData.PaymentDetails.FlightDeposit = cm.flight.PayUsNowAmount;
                    }

                    if (cm.marhaba) {
                        if (!cm.booking.UserData.ConnectingFlight.InboundFlightClass) {
                            cm.booking.UserData.ConnectingFlight.InboundFlightClass = 0;
                        }
                        if (!cm.booking.UserData.RequirementsList) {
                            cm.booking.UserData.RequirementsList = [];
                            cm.booking.UserData.RequirementsList[0] = { DisplayRoomNumber: -1, RequirementsText: '', RoomId: -1 };
                        }
                        if (!cm.booking.UserData.ChauffeurDetails && cm.basketRules.hasChauffeur) {
                            cm.booking.UserData.ChauffeurDetails = {};
                            //always use the date from the trip, never from anywhere else.
                            const marhabaDate = trip.MarhabaRequest.DateAndTime;
                            if (cm.booking.BookingRules.AllowChauffeurTimeEdit) {
                                //handle decimal values for ChauffeurMinAdvanceHours
                                const hours = Math.floor(cm.booking.BookingRules.ChauffeurMinAdvanceHours);
                                const minutes = Math.ceil((cm.booking.BookingRules.ChauffeurMinAdvanceHours - hours) * 60);
                                //subtract the hours and minutes
                                cm.MarhabaMaxDate = dateUtil.addHours(marhabaDate, hours * (-1));
                                if (minutes > 0) {
                                    cm.MarhabaMaxDate = dateUtil.addMinutes(cm.MarhabaMaxDate, minutes * (-1));
                                }
                                cm.MarhabaMinDate = dateUtil.addHours(cm.MarhabaMaxDate, cm.booking.BookingRules.ChauffeurTimeWindow * (-1));
                                cm.booking.UserData.ChauffeurDetails.PickupTime = cm.MarhabaMaxDate;
                            } else {
                                cm.booking.UserData.ChauffeurDetails.PickupTime = marhabaDate;
                            }
                        }
                        if (!cm.marhaba.Details.Date && trip.MarhabaRequest) {
                            cm.marhaba.Details.Date = trip.MarhabaRequest.DateAndTime;
                            cm.marhaba.Details.Terminal = trip.MarhabaRequest.Terminal;
                        }
                        cm.connectingFlightEnabled = cm.marhaba.Details.MarhabaQuote.Type === 2;
                        searchUnitService.restoreMarhabaSearch(trip);

                        cm.marhaba.Occupancy = _.get(trip, 'MarhabaRequest.Occupancy', {});
                    }

                    cm.showTransferDetails = function() {
                        broker.publish('showModalTransferDetails');
                    };

                    cm.showAttractionPreferredDates = cm.booking.UserData.AttractionDetails.some(
                        a => {
                        return a.CaptureDate;
                    });

                    if (trip.FromHolidayDeal) {
                        const ca = _.get(trip.HotelsRequest, 'Rooms[0].ChildAges', []);
                        const guests = _.get(cm.booking, 'UserData.Rooms[0].Guests', []);
                        if (guests) {
                            cm.booking.UserData.Rooms[0].Guests = guests.map(g => {
                                if (g.Type === 2) {
                                    g.Age = ca.pop();
                                }
                                return g;
                            });
                        }
                    }

                    bd4travel.trackBookingForm(false, cm.hotel, cm.flight, trip, cm.fees);

                    cm.totalCost = totalCost;
                    cm.paymentData = payments;
                    cm.balancesDue = balancesDue;
                    cm.packageBalanceDue = (cm.balancesDue && cm.balancesDue.length) ? cm.balancesDue[cm.balancesDue.length - 1].Due : null;
                    cm.totalCostExcludingDirectPayment = totalCostExcludingDirectPayment(parseFloat(cm.totalCost), cm.paymentData);
                    cm.costBreakdown.forEach(breakdown => { // Where id 20 is discount
                        cm.discount += breakdown.TypeId === 20 ? (breakdown.UnitAmount * breakdown.Quantity) : 0;
                    });

                    // Sum invisible price with hotel
                    cm.costBreakdown = cm.costBreakdown.map(breakdown => {
                        breakdown.TotalPrice = 0;
                        if (breakdown.TypeId === 1) { // Where id 1 is id of the hotel
                            breakdown.TotalPrice = (breakdown.UnitAmount * breakdown.Quantity);
                            cm.costBreakdown.forEach(invisible => {
                                // Where id 0 is id of the invisible price
                                if (invisible.TypeId === 0 && invisible.IsPriceHidden) {
                                    breakdown.TotalPrice += invisible.UnitAmount;
                                }
                            });
                        }

                        return breakdown;
                    });

                    const trackingData = {
                        TotalCost: cm.totalCost,
                        Hotel: cm.hotel,
                        Flight: cm.flight,
                        CarHire: cm.carhire,
                        Transfer: cm.transfer,
                        Attractions: cm.attractions,
                        Insurance: cm.insurance,
                        Parking: cm.parking,
                        PageVersion: bookingFormVersion,
                        Source: $routeParams.source
                    };

                    analytics.track('Event', 'BookingForm', trackingData);
                    analytics.track('mixpanel', 'BookingForm', trackingData);
                    analytics.track('Facebook', 'BookingForm', trackingData);
                    analytics.trackEvent({ category: 'searches', action: 'bookingPage' });

                    cards = arrayUtil.toDict(cm.booking.PaymentOptions, function(po) { return po.CardTypeId; });

                    if (cards && cm.booking.paymentOptions) {
                        cm.booking.paymentOptions = cm.booking.paymentOptions.filter(o => {
                                if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                                    return o.CardTypeId === 370;
                                } else if (TRPCONFIG.Domain.WPIframeUpdate) {
                                    return o.CardTypeId === 369;
                                }
                                return o.CardTypeId !== 370 && o.CardTypeId !== 369;

                            });
                    }

                    cm.paymentOptions = angular.copy(cm.booking.PaymentOptions);
                    cm.convertedPaymentOptions = paymentsUtilService.convertBookingPaymentOptions(
                                                                                angular.copy(cm.booking.PaymentOptions)
                                                );

                    let electronCardExclusion = true;
                    angular.forEach(cm.paymentOptions, function(v, k) {
                        if (v.IsPayPalPayment) {
                            cm.paymentOptions.splice(k, 1);
                            cm.payPalOption = v;
                        }
                        if (v.Type && v.Type.toLowerCase().indexOf('electron') > -1) {
                            electronCardExclusion = false;
                        }
                    });
                    cm.electronCardExclusion = electronCardExclusion;
                    cm.logosList = paymentsService.getLogosList(cm.booking.PaymentOptions);

                    cm.paymentTab = cm.booking.UserData.PaymentDetails.CardDetails.CardType === cm.payPalOption ? paymentTabOptions.PayPal : paymentTabOptions.Card;

                    const c = cm.booking.UserData.Contact;
                    c.manualAddress = c.manualAddress || (c.Address != null && c.Address !== '') || !cm.booking.BookingRules.EnablePostCodeLookup;

                    $timeout(function() {
                        $anchorScroll();
                    });

                    $scope.$watch('cm.booking.UserData.PaymentDetails.CardDetails.CardType', function(val) {
                        _updateCardFees(val);
                    });

                    if (bookingFormVersion === 2) {
                        $scope.$watch('cm.paymentModel.cardDetail.paymentOptionId', function(val) {
                            _updateCardFees(val);
                        });
                    }


                    if (TRPCONFIG.Domain.SavedCardsEnabled && authService.getUser().HardSignedIn) {
                        //When SavedCard is Enabled

                        cm.savedCards = cm.booking.SavedPaymentCards;
                        cm.booking.UserData.PaymentDetails.SaveThisCard = true; // Save a new card check box will be checked by default

                        cm.selectSavedCardTab = function() {
                            cm.paymentTab = paymentTabOptions.SavedCards;
                            cm.isSavedCard = true;
                            cm.selectedCard = cm.savedCards[0];
                            cm.booking.UserData.PaymentDetails.SaveThisCard = false;
                        };

                        if (cm.savedCards.length > 0) {
                            cm.selectSavedCardTab();
                        }

                        $scope.$watch('cm.selectedCard', function(c) {
                            if (c) {
                                cm.booking.UserData.PaymentDetails.CardDetails.CardType = c.CardTypeId;
                                cm.booking.UserData.PaymentDetails.CardDetails.CardId = c.CardId;
                            }
                        });

                        cm.confirmRemoveCard = function(card, ev) {
                            ev.stopPropagation();
                            card.showConfirmRemoveCard = true;
                        };

                        cm.removeCard = function(card, ev) {
                            ev.stopPropagation();
                            paymentsService.removeCard(card.CardId).then(function() {
                                cm.closeRemoveCard(card, ev);
                                card.isRemoved = true;
                                cm.savedCards = _.reject(cm.savedCards, function(c) { return c.isRemoved; });
                            });
                        };

                        cm.closeRemoveCard = function(card, ev) {
                            ev.stopPropagation();
                            card.showConfirmRemoveCard = false;
                        };

                        $scope.$on('auth:signout', function() {
                            clearSavedCards();
                        });

                        cm.convertedSavedCards = paymentsUtilService.convertBookingSavedCards(
                                                                                    cm.booking.SavedPaymentCards,
                                                                                    cm.booking.PaymentOptions
                        );
                    }

                    cm.selectPayPalTab = function() {
                        if (TRPCONFIG.Domain.PaypalInContextEnabled && !paypalInContextSet && $window.paypal) {
                            $window.paypal.checkout.setup(TRPCONFIG.Domain.PaypalMerchantId, {
                                environment: TRPCONFIG.PaypalInContextEnvironment,
                                container: 'paypal-button-container',
                                click: cm.book
                            });
                            paypalInContextSet = true;
                        }
                        cm.booking.UserData.PaymentDetails.CardDetails.CardType = cm.payPalOption.CardTypeId;
                        cm.paymentTab = paymentTabOptions.PayPal;
                        cm.isSavedCard = false;
                        cm.selectedCard = null;
                        cm.booking.UserData.PaymentDetails.SaveThisCard = false;
                        cm.booking.UserData.PaymentDetails.CardDetails.CardId = null;
                    };

                    cm.selectCardTab = function() {
                        cm.booking.UserData.PaymentDetails.CardDetails.CardType = cm.booking.cardOption;
                        cm.paymentTab = paymentTabOptions.Card;
                        cm.isSavedCard = false;
                        cm.selectedCard = null;
                        if (TRPCONFIG.Domain.SavedCardsEnabled && authService.getUser().HardSignedIn) {
                            cm.booking.UserData.PaymentDetails.SaveThisCard = true;
                        } else {
                            cm.booking.UserData.PaymentDetails.SaveThisCard = false;
                        }
                        cm.booking.UserData.PaymentDetails.CardDetails.CardId = null;
                    };

                    cm.updateCardType = function() {
                        cm.booking.UserData.PaymentDetails.CardDetails.CardNumber = undefined;
                        cm.booking.UserData.PaymentDetails.CardDetails.CardType = cm.booking.cardOption;
                        cm.isNotCash = cm.booking.cardOption !== 130;
                        cm.refreshEnbdObj();
                        if (cm.booking.cardOption === cm.enbdOptionId &&
                            cm.booking.UserData.PaymentDetails.CardDetails.MaskedCardNumber &&
                            cm.booking.UserData.PaymentDetails.CardDetails.MaskedCardNumber.length > cm.enbdDetails.cardNumberMinLength) {
                            cpgValidation();
                        }
                        if (cm.booking.cardOption === cm.enbdOptionId) {
                            cm.isBookingDisabled = true;
                        }
                    };

                    if (TRPCONFIG.Domain.PaymentPlanEnabled) {
                        cm.localChargesAmount = directPaymentAtHotelAmount(cm.paymentData);

                        if (TRPCONFIG.Domain2.MonthlyPaymentsEnabled && cm.booking.PaymentRules.RecurringPayments) {
                            cm.monthlyPayments = angular.copy(cm.booking.PaymentRules.RecurringPayments);
                            cm.monthlyPaymentsAllowed = Boolean(cm.monthlyPayments.Allowed);

                            if (cm.monthlyPaymentsAllowed) {
                                cm.monthlyPaymentsSchedule = getMonthlyPaymentsSchedule(cm.monthlyPayments);
                                cm.monthlyPaymentsAdminFee = cm.monthlyPayments.PaymentSchedules[0].Installments[0].AdminFee;

                                $scope.$watch('cm.payingMonthly', function(value) {
                                    if (value === true) {
                                        cm.payingFullAmount = null;
                                    }
                                });
                            }
                        }
                    }

                    if (cm.basketRules.depositAllowed || cm.monthlyPaymentsAllowed) {
                        cm.booking.UserData.PaymentDetails.PayFullAmount = cm.payingFullAmount = parseFloat(cm.booking.UserData.PaymentDetails.PaymentAmount) === parseFloat(totalCost);

                        paymentsCalculator.init(cm.paymentData, cm.booking.UserData.PaymentDetails.PaymentAmount, cm.payingFullAmount);


                        $scope.$watch('cm.payingFullAmount', function(val, oldVal) {
                            if (val != null && val !== oldVal) {
                                cm.payingMonthly = false;
                                cm.booking.UserData.PaymentDetails.PaymentAmount = parseFloat(val ? cm.totalCostExcludingDirectPayment : cm.minDeposit);
                                cm.booking.UserData.PaymentDetails.PayFullAmount = val;
                                cm.booking.UserData.PaymentDetails.PayByInstallments = false;
                                cm.booking.UserData.PaymentDetails.InstallmentScheduleType = 0;
                                if (!val) {
                                    cm.booking.paymentAmountInput = cm.minDeposit.toFixed(2);
                                }
                            }

                            if (val == null && cm.payingMonthly === true) {
                                cm.booking.UserData.PaymentDetails.PaymentAmount = parseFloat(cm.monthlyPaymentsSchedule[0].Amount);
                                cm.booking.UserData.PaymentDetails.PayFullAmount = false;
                                cm.booking.UserData.PaymentDetails.PayByInstallments = true;
                                cm.booking.UserData.PaymentDetails.InstallmentScheduleType = cm.monthlyPayments.PaymentSchedules[0].ScheduleType;
                            }
                            bookingService.updateBooking(bookingService.trimBooking(cm.booking));
                        });

                        $scope.$watch(function() {
                            return cm.booking.UserData.PaymentDetails.PaymentAmount;
                        }, function(val) {
                            if (cm.monthlyPaymentsAllowed && cm.payingMonthly) {
                                cm.booking.UserData.PaymentDetails.DepositAmount = parseFloat(cm.monthlyPaymentsSchedule[0].Amount);
                            } else {
                                cm.paymentData = paymentsCalculator.change(cm.payingFullAmount);
                                cm.booking.UserData.PaymentDetails.DepositAmount = val - cm.minDeposit;
                            }

                            if (cm.fees != null) {
                                if (cm.feeAmount != null && cm.feeAmount > 0) {
                                    cm.fees.CardHandlingFee = cm.feeAmount;
                                } else {
                                    cm.fees.CardHandlingFee = (val * (cm.feePercent / 100));
                                }
                            }
                            broker.publish('paymentDataUpdated', Object.assign(cm.paymentData, { payingFullAmount: cm.payingFullAmount }));
                        });
                    }

                    if (cm.monthlyPaymentsAllowed) {
                        cm.payingMonthly = true;
                        cm.payingFullAmount = null;
                        cm.booking.UserData.PaymentDetails.PaymentAmount = parseFloat(cm.totalCostExcludingDirectPayment);
                        cm.booking.UserData.PaymentDetails.PayFullAmount = null;
                    } else if (!cm.basketRules.depositAllowed) {
                        cm.booking.UserData.PaymentDetails.PaymentAmount = parseFloat(cm.totalCostExcludingDirectPayment);
                        cm.booking.UserData.PaymentDetails.PayFullAmount = true;
                        cm.payingFullAmount = true;
                    }

                    cm.updateDeposit = function(deposit) {
                        bookingService.updateDeposit(deposit, cm.booking.UserData.PaymentDetails, cm.totalCostExcludingDirectPayment, cm.minDeposit);
                    };

                    cm.selectCancellationProtection = () => {
                        let cancellationProtectionQuantity = 1;
                        switch (cm.checkbox.cancellationProtection) {
                            case true:
                                basketStore.addCancellationProtection(cm.hotel.ProductId, cm.cancellationProtection.Quote, cm.basketId, cancellationProtectionQuantity)
                                    .then(() => {
                                        broker.publish('bookingBasketUpdated');
                                    });
                                break;
                            case false:
                                basketStore.removeCancellationProtection(cm.hotel.ProductId, cm.cancellationProtection.Quote, cm.basketId)
                                    .then(() => {
                                        broker.publish('bookingBasketUpdated');
                                    });
                                break;
                        }
                    };

                    cm.checkCreditCardNumber = function(cardNumber) {
                        cm.cardChangedTo = undefined;
                        if (!cardNumber) { return; }

                        if (TRPCONFIG.Domain.EnableBinRangeDiscount === true) {
                            bookingService.getDiscountForCard(
                                bookingId,
                                cardNumber,
                                TRPCONFIG.Domain.DomainId,
                                TRPCONFIG.Domain.CultureCode
                            )
                            .then(res => {
                                cm.booking.Discounts = res;
                                broker.publish('discountUpdated', res);
                            });
                        }

                        paymentsService
                            .checkCardNumber(cm.booking.PaymentOptions, cardNumber, cm.booking.cardOption)
                            .then(undefined, function setCorrectCard(correctId) {
                                if (cm.booking.cardOption !== cm.enbdOptionId) {
                                    cm.booking.cardOption = correctId;
                                    cm.updateCardType();
                                    cm.cardChangedTo =
                                        paymentsService.getCardTitle(cm.booking.PaymentOptions, correctId);
                                } else if (cm.booking.cardOption === cm.enbdOptionId &&
                                           cm.booking.UserData.PaymentDetails.CardDetails.MaskedCardNumber &&
                                           cm.booking.UserData.PaymentDetails.CardDetails.MaskedCardNumber.length > cm.enbdDetails.cardNumberMinLength) {
                                    cpgValidation();
                                }
                                cm.booking.UserData.PaymentDetails.CardDetails.CardNumber =
                                        cardNumber;
                            });
                    };
                    // Used to automatically trust the html in agents' scripts
                    cm.trustHtml = function(htmlCode) {
                        return $sce.trustAsHtml(htmlCode);
                    };

                    broker.publish('unblock');
                    $scope.$emit('unblock');

                    const data = {
                        items: {
                            hotel: cm.hotel,
                            flight: cm.flight
                        },
                        price: hotelCost
                    };
                    criteoService.enqueue(data, 'basket', trip.TripType);
                    cm.bookingLoaded = true;
                    cm.showSectionStep2 = !!cm.hotel
                                            || cm.basketRules.captureInsurance
                                            || (cm.attractions && cm.attractions.length > 0)
                                            || cm.basketRules.captureVehicle
                                            || cm.basketRules.captureMainDriver;
                }
            });

        function threeDSValidationComplete(data) {
            if (cm.threeDsValidationComplete === false) {
                cm.threeDsValidationComplete = true;
                cm.booking.UserData.PaymentDetails.PaRes = data.paRes;
                cm.booking.UserData.PaymentDetails.PrePaymentID = data.prePaymentId;
                cm.booking.UserData.PaymentDetails.MD = data.md;
                cm.book();
                cm.threedsRedirecting = false;
            }
        }

        function cpgValidationComplete(threedsData) {
            if (threedsData && threedsData.PrePaymentID) {
                const prePaymentId = threedsData.PrePaymentID;
                bookingService.getCpgStatus(prePaymentId).then(data => {
                    const paRes = data && data.paRes;
                    if (data && data.error) {
                        onCpgStatusAPIError(data);
                    }
                    if (paRes) {
                        threeDSValidationComplete(data);
                    }
                });
            }
        }

        $scope.$on('3DSValidationComplete', function(ev, data) {
            threeDSValidationComplete(data);
            $scope.$apply(function() {
                cm.threedsRedirecting = false;
            });
        });

        $scope.$on('3DSValidationCancel', function() {
            $scope.$apply(function() {
                cm.threedsRedirecting = false;
            });
            broker.publish('unblock');
            $scope.$emit('unblock');
        });

        /*$scope.$on('3DSValidationCancelled', function() {
            $scope.$apply(function(){
                $scope.threedsRedirecting = false;
                $scope.busy = false;
            });
        });*/

        cm.book = book;
        cm.cpgValidationComplete = cpgValidationComplete;
        cm.setPaymentAndBook = setPaymentAndBook;

        cm.bypassThreeDS = function() {
            cm.booking.UserData.PaymentDetails.PaRes = '';
            cm.booking.UserData.PaymentDetails.PrePaymentID = cm.ThreeDSecure.PrePaymentID;
            cm.booking.UserData.PaymentDetails.MD = '';
            cm.booking.UserData.PaymentDetails.TL = '';
            cm.book();
            cm.threedsRedirecting = false;
        };

        cm.adminFeesApply = () => {
            return !cm.payingFullAmount && cm.payDepositAggregates && cm.payDepositAggregates.UnitAdminFee.Amount > 0;
        };

        cm.preBookCommands = [];

        cm.addPreBookCommand = command => {
            if (!cm.preBookCommands.includes(command)) {
                cm.preBookCommands.push(command);
            }
        };

        cm.generateTokens = () => {
            //figure out if we need to generate tokens and if there should be an expiry
            //if pci compliant
            const requireTokens = TRPCONFIG.Domain.PCICompliant;
            const month = cm.booking.UserData.PaymentDetails.CardDetails.ExpiryDate.Month;
            const year = cm.booking.UserData.PaymentDetails.CardDetails.ExpiryDate.Year;
            const save = cm.booking.UserData.PaymentDetails.SaveThisCard;
            const expiryDate = save && month != null && year != null ? new Date(year, month) : null;

            if (save && !expiryDate) {
                return $q.when(); //no point tokenising because the form is not valid
            }

            if (requireTokens) {
                return tokeniser.execute(expiryDate ? expiryDate.toISOString() : null);
            }
            return $q.when();
        };

        cm.addPreBookCommand(cm.generateTokens);

        cm.executePrebookCommands = async () => {
            if (cm.paymentModel.isPayPalPayment || cm.agentModeEnabled) {
                const onloadCommands = [...cm.preBookCommands.slice(0, 1)];
                await Promise.all(onloadCommands.map(preBookCommand => preBookCommand()));
            } else {

                const onloadCommands = [...cm.preBookCommands.slice(0, 2)];
                const [, id] = await Promise.all(onloadCommands.map(preBookCommand => preBookCommand()));
                if (id) {
                    cm.booking.UserData.PaymentDetails.DfReferenceId = id;
                }
            }

        };

        cm.getTotalOutstandingBalance = paymentData => {
            if (!paymentData) {
                return 0;
            }
            return paymentData.totalCosts - cm.booking.UserData.PaymentDetails.PaymentAmount - cm.getBookingDiscountValue();
        };

        cm.getBookingDiscountValue = () => {
            const bookingDiscounts = cm.booking.Discounts;

            return bookingDiscounts && bookingDiscounts[0] && bookingDiscounts[0].DiscountValue ? bookingDiscounts[0].DiscountValue : 0;
        };

        cm.getClosestPaymentDate = paymentData => {
            if (paymentData && paymentData.balanceSchedules && paymentData.balanceSchedules.length) {
                return paymentData.balanceSchedules[0].due;
            }
            return '';
        };

        function reloadPage() {
            window.location.reload();
        }

        cm.addVoucher = () => {
            cm.voucherCode = cm.voucherCodeInput;
            cookieService.set('VoucherCode', cm.voucherCode);
            const currentTrip = JSON.parse(window.localStorage.getItem('trip'));

            if (currentTrip && currentTrip.HotelInfo.ProductId) {
                    basketStore.addVoucher(cm.basketId, cm.voucherCode).then(data => {
                        bookingService.prepareBooking(data.BasketId, bookingId, cm.tripId).then(reloadPage).catch(reloadPage);
                    });
            }
        };

        cm.removeVoucher = () => {
            cm.voucherCodeInput = '';
            cm.voucherCode = '';
            cookieService.set('VoucherCode', '');

            basketStore.addVoucher(cm.basketId, cm.voucherCode).then(data => {
                cm.voucherDiscountMsg.Message = 'The code has been removed and your booking total updated';
                cm.voucherDiscountMsg.Code = 7;
                cookieService.set('VoucherWarnMessage', JSON.stringify(cm.voucherDiscountMsg));
                bookingService.prepareBooking(data.BasketId, bookingId, cm.tripId).then(reloadPage).catch(reloadPage);
            });
        };

        function book() {
            try {
                analytics.track('Event', 'Book', {
                    Revenue: cm.totalCost,
                    HotelTitle: cm.hotel && cm.hotel.Title
                });
            } catch (err) {}

            if (cm.booking.UserData.ChauffeurDetails && cm.booking.UserData.ChauffeurDetails.ContactNo) {
                cm.booking.UserData.ChauffeurDetails.ContactNo = cm.booking.UserData.ChauffeurDetails.ContactNo.replace(/ /g, '');
            } else {
                cm.booking.UserData.ChauffeurDetails = {};
            }

            TRPCONFIG.Domain.PaypalInContextEnabled && cm.isPayPal
                ? $window.paypal.checkout.initXO()
                : _block(true);

            const booking = bookingService.trimBooking(cm.booking);

            bookingService.book(booking, cm.tripId, cm.basketId).then(result => {
                if (result.Status === bookingStatus.PayPalVerification) {
                    bookingService.paypalPostBooking(result.PayPal);
                } else if (result.Status === bookingStatus.ThreeDs || result.Status === bookingStatus.Cpg ||
                        result.Status === bookingStatus.HostedPayment || result.Status === bookingStatus.WPHostedPayment) {
                    if (cpgStatusApiEnabled && result.Status !== bookingStatus.HostedPayment && result.Status !== bookingStatus.WPHostedPayment) {
                        cm.cpgValidationComplete(result.ThreeDSecure);
                    }
                    if (result.Status === bookingStatus.WPHostedPayment) {
                        cm.ThreeDSecure = result.ThreeDSecure;
                        $scope.$broadcast('wpHostedPaymentInit', result.ThreeDSecure);
                        cm.WPHostedRedirect = true;

                    } else {
                        $scope.$broadcast('request3DSValidation', result.ThreeDSecure);
                        cm.threedsRedirecting = true;
                        cm.ThreeDSecure = result.ThreeDSecure;

                    }
                    broker.publish('unblock');
                    $scope.$emit('unblock');

                } else if (result.Status === bookingStatus.Refresh) {
                    if (result.RefreshResponse && result.RefreshResponse.StaleProducts && result.RefreshResponse.StaleProducts.length > 0) {

                        //check for a navl product
                        const navlProduct = _.find(result.RefreshResponse.StaleProducts, p => p.NewProductId === null);
                        if (navlProduct) {
                            analytics.track('mixpanel', 'PUPNAVL Pop-up', { Type: 'NAVL' });
                            modalService.launch('partials/popups/navl', { popupType: 'NAVL' }, true, true);
                        }
                        //check for a pup product
                        const pupProducts = _.filter(result.RefreshResponse.StaleProducts, p => p.NewProductId !== null);
                        if (pupProducts.length > 0) {
                            _getCostBreakdown(result.RefreshResponse.Basket.BasketId).then(cb => {
                                let dataForPup = cb;
                                _.forEach(pupProducts, pupProduct => {
                                    if (pupProduct.Product.ProductType === 0) {
                                        dataForPup.oldHotelCost = pupProduct.Product.TotalAmount;
                                        dataForPup.oldHolidayCost = dataForPup.oldHotelCost + dataForPup.flightCost;
                                        dataForPup.pupAmount = dataForPup.pupAmount ? dataForPup.pupAmount + dataForPup.hotelCost - dataForPup.oldHotelCost : dataForPup.hotelCost - dataForPup.oldHotelCost;
                                    } else if (pupProduct.Product.ProductType === 1) {
                                        //isolate ATOL from old cost breakdown
                                        const atol = _.find(cm.costBreakdown, item => {
                                            return item.Description.indexOf('ATOL') >= 0;
                                        });
                                        if (atol) {
                                            dataForPup.oldFlightCost = pupProduct.Product.TotalAmount - atol.UnitAmount * atol.Quantity; // subtract the atol cost from the flights total
                                        } else {
                                            dataForPup.oldFlightCost = pupProduct.Product.TotalAmount;
                                        }
                                        dataForPup.oldHolidayCost = dataForPup.oldFlightCost + dataForPup.hotelCost;
                                        dataForPup.pupAmount = dataForPup.pupAmount ? dataForPup.pupAmount + dataForPup.flightCost - dataForPup.oldFlightCost : dataForPup.flightCost - dataForPup.oldFlightCost;
                                    }
                                });
                                broker.publish('updatePricesOnPUP');
                                dataForPup.currencyCode = cm.currencyCode;
                                dataForPup.packagePrice = cm.packagePrice;
                                dataForPup.basketId = result.RefreshResponse.Basket.BasketId;
                                analytics.track('mixpanel', 'PUPNAVL Pop-up', { Type: 'PUP', PUPAmount: dataForPup.pupAmount });
                                modalService.launch('partials/popups/pup', { dataForPup, popupType: 'PUP' }, true, true);
                            });
                        }
                        broker.publish('unblock');
                        $scope.$emit('unblock');
                    }
                } else if (result.Messages && result.Messages.length > 0) {
                    setTimeout(() => analytics.track('mixpanel', 'FormValidation', { validationMessages: result.Messages }));
                    $scope.$broadcast('flash:error', result.Messages);
                    cm.threeDsValidationComplete = false;
                    scrollService.scrollTo('#booking-form-wrapper', { animate: true, offset: 200 });
                    broker.publish('unblock');
                    $scope.$emit('unblock');
                    delete cm.booking.UserData.PaymentDetails.PaRes;
                    delete cm.booking.UserData.PaymentDetails.PrePaymentID;
                    cm.hideForm = true;
                } else {
                    analytics.track('eCommerce', 'purchase', result);

                    const bookingConfirmAdFormItem = {
                        totalCost: cm.paymentTotalWithCardFee || 0,
                        estabId: cm.hotel && cm.hotel.Details && cm.hotel.Details.Id ? cm.hotel.Details.Id.toString() : '',
                        bookingReference: result.BookingReferences[0],
                        currency: cm.currencyCode
                    };

                    sessionStorage.setItem('BookingConfirmAdFormItem', JSON.stringify(bookingConfirmAdFormItem));

                    bd4travel.trackBookingForm(true, cm.hotel, cm.flight, trip, cm.fees).then(() => {
                        basketService.redirectToComplete(result.BookingReferences, basketId, cm.totalCost, cm.tripId);
                        if (adFormService.isNewsletterSignUpEventEnabled()
                            && cm.booking.UserData && cm.booking.UserData.Contact && cm.booking.UserData.Contact.EmailSignUp) {
                            analytics.trackAdformClick({
                                eventName: 'Newslettersignup',
                                trackingId: adFormService.getTrackingId()
                            });
                        }
                    });
                }
            });
        }

        function setPaymentAndBook(payFullAmount) {
            paymentsUtilService.copyCardDetailsToUserData(cm.paymentModel, cm.booking.UserData.PaymentDetails);
            const paymentAmount = parseFloat(payFullAmount ? cm.totalCostExcludingDirectPayment : cm.minDeposit);

            if (payFullAmount === null && cm.monthlyPaymentsAllowed) {
                cm.booking.UserData.PaymentDetails.PaymentAmount = parseFloat(cm.monthlyPaymentsSchedule[0].Amount);
                cm.booking.UserData.PaymentDetails.PayFullAmount = false;
                cm.booking.UserData.PaymentDetails.PayByInstallments = true;
                cm.booking.UserData.PaymentDetails.InstallmentScheduleType = cm.monthlyPayments.PaymentSchedules[0].ScheduleType;
                cm.booking.UserData.PaymentDetails.DepositAmount = cm.booking.UserData.PaymentDetails.PaymentAmount;
            } else {
                cm.booking.UserData.PaymentDetails.PaymentAmount = paymentAmount;
                cm.booking.UserData.PaymentDetails.PayFullAmount = cm.payingFullAmount = payFullAmount;
                cm.booking.UserData.PaymentDetails.PayByInstallments = false;
                cm.booking.UserData.PaymentDetails.InstallmentScheduleType = 0;
                //the following seems very silly, surely the API should be able to figure this out
                //but it needs to be set otherwise we'd only take the deposit amount from the customer
                cm.booking.UserData.PaymentDetails.DepositAmount = paymentAmount - cm.minDeposit;
            }
            trackAndBook(payFullAmount);
        }

        async function getDfReferenceId() {
           const newCommands = [cm.preBookCommands[cm.preBookCommands.length - 1]];
            const [id] = await Promise.all(newCommands.map(preBookCommand => preBookCommand()));
            return id;
        }

        async function threeDS2Book() {
            try {
                _block(true);
                const id = await getDfReferenceId();
                const dfReferenceId = id || $rootScope.dfReferenceId;
                cm.booking.UserData.PaymentDetails.DfReferenceId = dfReferenceId;
                book();
            } catch (err) {
                broker.publish('unblock');
                $scope.$emit('unblock');
                console.log('err', err);
            }
        }

        function trackAndBook(FullAmountPaid) {
            const TypeTitle = Object.keys(tripService.tripTypes).find(
                item => tripService.tripTypes[item] === cm.trip.TripType
            );
            analytics.track('mixpanel', 'BookingFormClick', {
                TypeTitle,
                DepositAvailable: cm.basketRules.depositAllowed,
                FullAmountPaid
            });
            if (TRPCONFIG.Domain.WPIframeUpdate && !cm.paymentModel.isPayPalPayment) {
                book();
            } else if (cm.agentModeEnabled || cm.paymentModel.isPayPalPayment) {
                cm.booking.UserData.PaymentDetails.DfReferenceId = null;
                book();
            } else if (cm.booking.UserData.PaymentDetails.DfReferenceId) {
               book();
            } else if (cm.threeDS2Enabled) {
                threeDS2Book();
            } else {
               book();
            }
        }

        cm.trackAndBook = trackAndBook;
    }, basketService.bookingAlreadyDone(`bookingCtrl : '${$routeParams.tripId}'`));

    function _block(completing) {
        $scope.$emit('block', {
            title: resourceService.get(completing ? 'COMPLETINGBOOKING' : 'PREPARINGBOOKING'),
            loadingScreenStyle: 'booking-bookingCtrl'
        });
    }

    function totalCostExcludingDirectPayment(totalCost, paymentData) {
        let directPaymentCost = 0;
        angular.forEach(paymentData.products, function(prod) {
            angular.forEach(prod.directPayments, function(dp) {
                directPaymentCost += dp.amount;
            });
        });

        //It should be equal to, paymentData.totalBalances + paymentData.minimumDeposit
        return totalCost - directPaymentCost;
    }

    function getMonthlyPaymentsSchedule(data) {
        const monthlyPaymentsSchedule = _.find(data.PaymentSchedules, ['ScheduleType', 1]);

        return monthlyPaymentsSchedule.Installments.map(installment => {
            return {
                Due: installment.DueDate,
                Amount: installment.InstallmentCost
            };
        });
    }

    function watchDeliveryOptions() {
        const deliveryOptions = cm.booking.DeliveryOptions;

        if (deliveryOptions && deliveryOptions.length) {
            $scope.$watch('cm.booking.UserData.DeliverySupplierId', v => {
                if (v != null) {
                    cm.delivery = deliveryOptions.reduce(
                        (delivery, option) => {
                            if (v === option.SupplierId) {
                                option.Selected = true;
                                delivery.desc = option.Title;
                                delivery.total = option.Price;
                            } else {
                                option.Selected = false;
                            }
                            return delivery;
                        }, { total: 0 }
                    );
                }
            });
        }
    }

    function signIn() {
        let url = `${$location.path().substring(1)}?pb=1`;
        authService.bufferRoute(url);
        url = `signin?cb=${encodeURIComponent(url)}`;
        $location.url(url);
    }

    function signOut() {
        authService.signOut();
        bookingService.clearContact(cm.booking.UserData);
        bookingService.clearGuests(cm.booking.UserData.Rooms);
        bookingService.updateBooking(bookingService.trimBooking(cm.booking));
    }

    function copyFromContact(e) {
        bookingService.copyFromContact(cm.booking, e);
    }

    cm.formatPaymentAmountInput = function(depositAmount) {
        if (depositAmount.$valid) {
            cm.booking.paymentAmountInput = parseFloat(cm.booking.paymentAmountInput).toFixed(2);
        }
    };

    function directPaymentCaveat(product, payment) {
        const res = product.productType === 0 ? 'DIRECTACCOMPAYMENTADVICE' : 'DIRECTFLIGHTPAYMENTADVICE';
        if (payment.localCurrency === payment.currency) {
            return String.format(resourceService.get(res), $filter('customCurrency')(payment.amount, payment.currency));
        }
        return String.format(resourceService.get(res), `${$filter('customCurrency')(payment.localAmount, payment.localCurrency)} ${String.format(resourceService.get('CUSTOMEREQUIVALENT'), $filter('customCurrency')(payment.amount, payment.currency))}`);
    }

    function directPaymentAtHotelAmount(paymentData) {
        const hotelPayment = _.find(paymentData.products, ['productType', 0]);

        if (!hotelPayment) { return; }

        cm.hasLocalCharges = hotelPayment.directPayments && hotelPayment.directPayments.length > 0;

        if (!cm.hasLocalCharges) { return; }

        const directPayments = hotelPayment.directPayments[0];

        return $filter('customCurrency')(directPayments.amount, directPayments.currency);
    }

    function clearSavedCards() {
        cm.savedCards = null;
        cm.convertedSavedCards = null;
        cm.selectCardTab();
    }

    function _updateCardFees(val) {
        if (val == null || val === 0 || cards[val] == null) {
            cm.isPayPal = false;
            cm.fees = null;
            broker.publish('feesUpdated', cm.fees);
            return;
        }
        cm.booking.UserData.PaymentDetails.CardDetails.PaymentTypeId = cards[val].PaymentTypeId;
        cm.fullCardDetails = cards[val].FullDetails;
        cm.feePercent = cards[val].FeePercent;
        cm.feeAmount = cards[val].FeeAmount || 0;
        cm.isPayPal = cards[val].IsPayPalPayment;
        basketStore.setPaymentMethod(cards[val].CardTypeId, cm.basketId).then(function(fees) {
            cm.fees = fees;
            if (cm.feeAmount != null && cm.feeAmount > 0) {
                cm.fees.CardHandlingFee = cm.feeAmount;
            } else {
                cm.fees.CardHandlingFee = (cm.booking.UserData.PaymentDetails.PaymentAmount * (cm.feePercent / 100));
                cm.fees.CardHandlingForTotal = cm.totalCostExcludingDirectPayment * (cm.feePercent / 100);
            }
            broker.publish('feesUpdated', cm.fees);
        });
    }

    broker.subscribe('paymentPlusFee', 'feesUpdated', _setPaymentTotalPlusFees);
    broker.subscribe('paymentPlusFee', 'paymentDataUpdated', _setPaymentTotalPlusFees);

    function _setPaymentTotalPlusFees() {
        const cardFee = cm.fees && cm.fees.CardHandlingFee || 0;
        const cardFeeForTotal = cm.fees && cm.fees.CardHandlingForTotal || 0;
        cm.paymentAmountWithCardFee = parseFloat(cm.booking.UserData.PaymentDetails.PaymentAmount) + cardFee;
        cm.paymentTotalWithCardFee = cm.totalCostExcludingDirectPayment + cardFeeForTotal;
    }

    cm.customerCreditCheck = customerCreditCheck;
    function customerCreditCheck(item) {
        cm.customer = item;
        cm.customer.showCreditCheckResult = true;
        cm.customer.creditCheckResponseText = resourceService.get('CHECKINGCREDIT');
        cm.customer.creditCheckStatus = null;
        cm.customer.CreditCheckPassed = 'red';
        agentModeService.getCreditCheck(item.Id, cm.booking.UserData.PaymentDetails.PaymentAmount).then(function(data) {
            cm.customer.creditCheck = data;
            cm.customer.creditCheckResponseText = cm.customer.creditCheck.ResponseText;
            cm.booking.UserData.PaymentDetails.CustomerId = item.Id;
            cm.booking.UserData.PaymentDetails.CustomerName = item.Title;
            //showing credit check status, color of status, check passed or failed
            if (cm.customer.creditCheck.StatusId === 1) {
                cm.customer.creditCheckStatus = 'green';
            } else {
                cm.customer.creditCheckStatus = 'red';
            }
            if (cm.customer.creditCheck.StatusId === 5) {
                cm.customer.showCreditCheckResult = false;
            }
            if (!(cm.customer.creditCheck.StatusId === 2 || cm.customer.creditCheck.StatusId === 3 || cm.customer.creditCheck.StatusId === 4)) {
                cm.customer.CreditCheckPassed = 'green';
            }
        });
    }

    function _prepareBookingSubscriber(basketId, trip) {
        //only applies to insurance currently, but we may need to prepare the booking again
        broker.subscribe('bookingCtrl', 'bookingBasketUpdated', function(userData) {
            bookingService.prepareBooking(basketId, trip.BookingId, $routeParams.tripId, userData.data)
                .then(function() {
                    return $q.all([
                        basketStore.payments(basketId),
                        basketStore.costBreakdown(basketId, $routeParams.productId),
                        basketStore.totalDeposit(basketId, $routeParams.productId),
                        basketStore.totalCost(basketId)
                    ]).then(function([payments, costBreakdown, totalDeposit, totalCost]) {
                        cm.paymentData = payments;
                        cm.costBreakdown = costBreakdown;
                        cm.totalDeposit = totalDeposit;
                        cm.totalCost = totalCost;
                        cm.minDeposit = cm.totalDeposit;
                        cm.booking.UserData.PaymentDetails.PaymentAmount = cm.booking.paymentAmountInput = (cm.minDeposit + cm.booking.UserData.PaymentDetails.DepositAmount).toFixed(2);
                        cm.booking.UserData.PaymentDetails.PayFullAmount = parseFloat(cm.booking.UserData.PaymentDetails.PaymentAmount) === parseFloat(totalCost);
                        cm.totalCostExcludingDirectPayment = totalCostExcludingDirectPayment(parseFloat(cm.totalCost), cm.paymentData);
                        paymentsCalculator.init(cm.paymentData, cm.booking.UserData.PaymentDetails.PaymentAmount, cm.payingFullAmount);
                        //a little un tidy but to fix the card fees not updating when changing insurance
                        // for both versions of the form need to do the following
                        _updateCardFees(cm.paymentModel.cardDetail.paymentOptionId ||
                            cm.booking.UserData.PaymentDetails.CardDetails.CardType);
                    });
                });
        });
    }

    cm.customerAutoCompleterDeselect = customerAutoCompleterDeselect;
    function customerAutoCompleterDeselect() {
        cm.customer = null;
    }

    cm.setChauffeurDate = function(date) {
        cm.booking.UserData.ChauffeurDetails.PickupTime = date;
    };

    cm.openTakingPaymentModal = e => {
        e.preventDefault();
        e.stopPropagation();
        cm.showTakingPaymentModal = true;
        bookingService.pauseRecording(TRPCONFIG.ClientIpAddress);
    };

    cm.closeTakingPaymentModal = e => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        cm.showTakingPaymentModal = false;
        bookingService.resumeRecording(TRPCONFIG.ClientIpAddress);
    };

    cm.securityCodeOnMask = () => {
        cm.isSecurityCodeMasked = true;
    };

    cm.hidePaymentForms = () => _.get(cm, 'booking.RebookDetails.Difference') <= 0;

    cm.updateDfReferenceId = dfReferenceId => cm.booking.UserData.PaymentDetails.DfReferenceId = dfReferenceId;

    broker.subscribe('bookingCtrl', 'confirmPUP', e => {
        //fetch the new payment info and advance to booking
        const basketId = e.data.basketId;
        $q.all([
            basketStore.payments(basketId),
            basketStore.totalDeposit(basketId, $routeParams.productId),
            basketStore.totalCost(basketId)
        ]).then(function([payments, totalDeposit, totalCost]) {
            cm.paymentData = payments;
            cm.totalDeposit = totalDeposit;
            cm.totalCost = totalCost;
            cm.minDeposit = cm.totalDeposit;
            cm.totalCostExcludingDirectPayment = totalCostExcludingDirectPayment(parseFloat(cm.totalCost), cm.paymentData);
            paymentsCalculator.init(cm.paymentData, cm.booking.UserData.PaymentDetails.PaymentAmount, cm.payingFullAmount);
            const paymentAmount = parseFloat(cm.booking.UserData.PaymentDetails.PayFullAmount ? cm.totalCostExcludingDirectPayment : cm.minDeposit);
            cm.booking.UserData.PaymentDetails.PaymentAmount = paymentAmount;
            cm.booking.UserData.PaymentDetails.DepositAmount = paymentAmount - cm.minDeposit;
            _setPaymentTotalPlusFees();
            cm.book();
        });
    });

    function _getCostBreakdown(basketId) {
       return basketStore.rehydrateBasketForPUP(basketId).then(() => {
            return $q.all([
                basketStore.totalDiscount(basketId),
                basketStore.totalDeposit(basketId, $routeParams.ProductId),
                basketStore.costBreakdownGrouped(basketId),
                basketStore.rules(basketId, $routeParams.ProductId),
                basketStore.payDirectTotal(basketId),
                basketStore.carHire(basketId),
                basketStore.isAtolProtected(basketId)
            ]).then(([
                totalDiscount,
                totalDeposit,
                costBreakdownGrouped,
                rules,
                payDirectTotal,
                carHire,
                isAtolProtected
            ]) => {
                let dataForPup = {};
                dataForPup.totalDiscount = totalDiscount;
                dataForPup.totalDeposit = totalDeposit;
                dataForPup.costBreakdownGrouped = costBreakdownGrouped;
                dataForPup.totalCostGrouped = costBreakdownGrouped.total;
                dataForPup.atolAvailable = isAtolProtected;
                _.each(costBreakdownGrouped, cb => {
                    if (cb.group === 1) {
                        // HOTEL
                        dataForPup.hotelCost = cb.costBreakdown
                            .filter(cost => cost.TypeId === costBreakdownCodes.Hotel)
                            .reduce((totalCost, currentHotel) => totalCost + currentHotel.UnitAmount, 0);
                        dataForPup.cancellationProtection = _.get(cb.costBreakdown.find(cost =>
                            cost.TypeId === costBreakdownCodes.CancellationProtection), 'UnitAmount', 0);
                    } else if (cb.group === 2) {
                        // FLIGHTS
                        // Isolate the ATOL cost
                        // Ideally we would be able to search by type but we have to use the description
                        const atol = _.find(cb.costBreakdown, item => {
                            return item.Description.indexOf('ATOL') >= 0;
                        });
                        if (atol) {
                            dataForPup.atolCost = atol.UnitAmount * atol.Quantity;
                            dataForPup.flightCost = cb.total - dataForPup.atolCost; // subtract the atol cost from the flights total
                        } else {
                            dataForPup.flightCost = cb.total;
                        }
                    } else if (cb.group === 3) {
                        // EXTRAS
                        dataForPup.extraCost = cb.total;
                        dataForPup.extras = basketStore.extrasBreakdown(cb.costBreakdown);
                    }
                });
                dataForPup.hasDeposit = rules.depositAllowed;
                dataForPup.hasPayDirect = payDirectTotal > 0;
                let carHireExtras = _.get(carHire, 'RequestedItems');
                if (carHireExtras && carHireExtras.length === 0) {
                    carHireExtras = [{
                        Quantity: 1,
                        UnitAmount: _.get(carHire, 'TotalAmount')
                    }];
                }
                dataForPup.carHireExtras = carHireExtras;
                dataForPup.carHireExtrasTotal = carHireExtras ?
                    carHireExtras.reduce((total, extra) => total += extra.UnitAmount, 0) :
                    undefined;
                return dataForPup;
            });
       });
    }

    function isDiscountApplied() {
        return cm.booking.Discounts && cm.booking.Discounts.length;
    }

    function isHFareFlightType() {
        return flightDetail.isHFlightType(_.get(cm.flight, 'Details.Itinerary', false));
    }

    function cpgValidation() {
        cm.refreshEnbdObj();
        cm.changeOtpCode();
        cm.enbdDetails.isCpgInProgress = true;
        cm.isBookingDisabled = true;
        cm.booking.UserData.PaymentDetails.LoyaltyCardDetails = null;
        cm.booking.UserData.PaymentDetails.CardDetails.otpConfirmationCode = null;

        cm.generateTokens().then(() => {
            cm.enbdDetails.cardNumber = cm.booking.UserData.PaymentDetails.CardDetails.CardNumber;
            paymentsService.cpgValidation(cm.enbdDetails).then(function(res) {
                if (res.data.Status === 1) {
                    cm.enbdDetails.isCpgInProgress = false;
                    cm.enbdDetails.isCpgValid = true;
                    cm.enbdDetails.SessionToken = res.data.SessionToken;
                    cm.enbdDetails.TransactionId = res.data.TransactionId;
                } else {
                    cm.enbdDetails.isCpgValid = false;
                    cm.enbdDetails.isCpgInProgress = false;
                }
            }, () => {
                cm.enbdDetails.isCpgValid = false;
                cm.enbdDetails.isCpgInProgress = false;
            });
        });
    }

    cm.otpValidation = () => {
        let options = Object.assign(cm.enbdDetails);
        cm.enbdDetails.isOtpInProgress = true;
        options.OTP = parseInt(cm.booking.UserData.PaymentDetails.CardDetails.otpConfirmationCode);
        paymentsService.verifyOtp(options).then(res => {
            if (res.data && res.data.Status === 1) {
                cm.enbdDetails.isOtpInProgress = false;
                cm.enbdDetails.balanceData = res.data;
                cm.enbdDetails.availablePoints = cm.enbdDetails.balanceData.LoyaltyPoints.AvailablePoints *
                                        cm.enbdDetails.balanceData.LoyaltyPoints.RedemptionRate;
                cm.enbdDetails.isOtpValid = true;

                cm.enbdDetails.pointsToRedeem = cm.totalCost > cm.enbdDetails.availablePoints
                                                ? cm.enbdDetails.availablePoints
                                                : cm.totalCost;
                cm.enbdDetails.remainingPoints = cm.enbdDetails.availablePoints - cm.enbdDetails.pointsToRedeem < 0
                                                ? 0 : cm.enbdDetails.availablePoints - cm.enbdDetails.pointsToRedeem;
                cm.enbdDetails.amountToRedeem = cm.enbdDetails.pointsToRedeem !== cm.totalCost
                                                ? cm.totalCost - cm.enbdDetails.pointsToRedeem : 0;
            } else {
                cm.enbdDetails.isOtpValid = false;
                cm.enbdDetails.isOtpInProgress = false;
            }
        }, () => {
            cm.enbdDetails.isOtpValid = false;
            cm.enbdDetails.isOtpInProgress = false;
        });
    };

    cm.resendOtpConfirmation = () => {
        cm.enbdDetails.isOtpValid = null;
        cm.enbdDetails.isOtpResent = false;
        cm.booking.UserData.PaymentDetails.CardDetails.otpConfirmationCode = null;
        paymentsService.resendOtpConfirmation(cm.enbdDetails).then(res => {
            if (res.data.Status === 1) {
                cm.enbdDetails.isCpgValid = true;
                cm.enbdDetails.isOtpResent = true;
            } else {
                cm.enbdDetails.isCpgValid = false;
            }
        });
    };

    cm.usePoints = () => {
        cm.enbdDetails.isPointsPaymentApproved = true;
        cm.booking.UserData.PaymentDetails.LoyaltyCardDetails = {};
        cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.RedeemedPoints = cm.enbdDetails.pointsToRedeem;
        cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.ProductId = cm.enbdDetails.balanceData.LoyaltyPoints.ProductId;
        cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.SessionToken = cm.enbdDetails.SessionToken;
        cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.TransactionId = cm.enbdDetails.TransactionId;
        cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.LoyaltyCardSplitPaymentAmount = cm.enbdDetails.amountToRedeem;
        cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.LoyaltyCardNumber = cm.enbdDetails.cardNumber;
        cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.MaskedLoyaltyCardNumber =
        cm.booking.UserData.PaymentDetails.CardDetails.MaskedCardNumber;
        bookingService.updateBooking(bookingService.trimBooking(cm.booking));
        cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.RedeemedPoints > 0 ? cm.isBookingDisabled = false : cm.enbdDetails.showZeroBalanceAlert = true;
    };

    cm.changeOtpCode = () => {
        if (cm.enbdDetails.isOtpValid) {
            cm.enbdDetails.isOtpValid = null;
        }
    };

    cm.refreshEnbdObj = () => {
        const staticProps = ['domainId', 'currencyCode'];
        cm.booking.UserData.PaymentDetails.CardDetails.otpConfirmationCode = null;
        cm.isBookingDisabled = false;
        for (let prop in cm.enbdDetails) {
            if (staticProps.indexOf(prop) === -1) {
                cm.enbdDetails[prop] = null;
            }
        }
    };


    function wpHostedBookingCheckAndComplete(wpHostedResponse) {
        try {
            const { prepaymentid, response } = wpHostedResponse;
            const { gateway, order } = response;
            const { status } = order;
            if (status === 'cancelled_by_shopper') {
                cm.WPHostedRedirect = false;
            } else if (status === 'success') {
                const { mac2, paymentAmount, paymentCurrency, paymentStatus, orderKey } = gateway;
                const paRes = `${orderKey},${paymentAmount},${paymentCurrency},${paymentStatus}:${mac2}`;
                cm.booking.UserData.PaymentDetails.PaRes = paRes;
                cm.booking.UserData.PaymentDetails.PrePaymentID = prepaymentid;
                cm.book();
            } else {
                let errorMessage = '';
                if (status === 'failure') {
                    errorMessage = `${resourceService.get('WP_HOSTED_PAYMENT_FAILED_TEXT')}`;
                } else if (status === 'error') {
                    errorMessage = `${resourceService.get('WP_HOSTED_PAYMENT_ERROR_TEXT')}`;
                } else {
                   errorMessage = `${resourceService.get('WP_HOSTED_PAYMENT_ERROR_TEXT')}`;
                }
                $scope.$broadcast('flash:error', errorMessage);
            }
        } catch (e) {
            console.log('Error in handling WP hosted response');
        }
        cm.WPHostedRedirect = false;
    }
    $scope.$on('WPHostedResponseHandler', function(ev, data) {
        wpHostedBookingCheckAndComplete(data);
        $scope.$apply(function() {
            cm.threedsRedirecting = false;
        });
    });
}
})();
